import { IntegrationPageTemplate } from '@/components/IntegrationPageTemplate'
import { getIntegration } from '@/data/integrations'

export default function StripeIntegrationPage() {
  return <IntegrationPageTemplate integration={getIntegration('stripe')} />
}
